/* eslint-disable @typescript-eslint/prefer-ts-expect-error,@typescript-eslint/ban-ts-comment -- process */
export const fallbackLng = 'en-US';
export const languages = [fallbackLng, 'en', 'de', 'fr', 'fr-FR', 'ar-AE', 'ar', 'es', 'es-ES'];
export const defaultNS = 'common';
export const cookieName = 'i18next';
// https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
export function getOptions(lng = fallbackLng, ns = defaultNS) {
  return {
    // @ts-ignore
    // debug: process.env.NODE_ENV === 'development' && typeof window !== 'undefined',
    debug: false,
    supportedLngs: languages,
    fallbackLng: 'en', // since files are inside en folder
    nonExplicitSupportedLngs: true,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
    interpolation: {
      escapeValue: false,
    },
  };
}
